import type { ChangeEvent } from 'react';

import { getSeparators, parseNumber } from '../../../../../utils/number';

// TODO: Write a unit test
export const isNumberOrNullOrDecimalSeparator = (
  event: ChangeEvent<HTMLInputElement>,
): boolean => {
  const nativeEvent: InputEvent = event.nativeEvent as InputEvent;
  const value = event.target.value;
  const input = nativeEvent.data;

  if (input === null && isNaN(parseNumber(value)) && value !== '') {
    return false;
  }

  return (
    input === null || /[0-9]/.test(input) || input === getSeparators().decimal
  );
};
